import { FormControl } from '@angular/forms';

export function validateDealerId(c: FormControl) {
  const test = !c.value || /^\d*$/.test(c.value);

  return test ? null : {
    validDealerId: {
      valid: false
    }
  };
}
